import './styles/ExecutionContent.scss';

import { Empty } from '@whistler-ui/k2/components/Empty';
import { useClassHelper } from '@whistler-ui/k2/hooks';
import { Maybe } from '@whistler-ui/k2/types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  commonPageStylesIdentifier,
  CREATED,
  RUNNING,
  TEST_STATUSES,
} from '../../constants';
import { GRAPH_LABELS } from '../../constants/graphConstants';
import { ExecutionTest } from '../../types';
import { ExecutionGraph } from '../ExecutionGraph/ExecutionGraph';
import { ExecutionItemInfo } from './components/ExecutionItemInfo';
import { componentName } from './constants';

interface Props {
  data: ExecutionTest;
}

export const ExecutionContent = ({ data }: Props) => {
  const [activeItem, setActiveItem] = useState<Maybe<string>>(null);

  const c = useClassHelper(componentName);
  const commonC = useClassHelper(commonPageStylesIdentifier);
  const { t } = useTranslation();

  const [errorKey, websheetKey, isWebsheetOpen] = getExecParams(data);

  return (
    <>
      {data.api_test_executions.length > 0 && (
        <div className={c('__graph')}>
          <ExecutionGraph
            activeItem={activeItem}
            tagName={data.test_case_tag}
            executions={data?.api_test_executions}
            setActiveItem={(label: string) => setActiveItem(label)}
            errorKey={GRAPH_LABELS[errorKey]}
            websheetKey={isWebsheetOpen && GRAPH_LABELS[websheetKey]}
            status={data.status}
            useCaseTag={data.use_case_tag}
          />
        </div>
      )}
      <div className={c('__columns')}>
        {data.api_test_executions.length > 0
          ? data.api_test_executions?.map((useCase, i, array) => {
              return (
                <ExecutionItemInfo
                  key={`${data.test_case_tag}-${i}`}
                  index={i}
                  activeItem={activeItem}
                  setActiveItem={label => setActiveItem(label)}
                  componentName={componentName}
                  useCase={useCase}
                  isWebsheetOpen={isWebsheetOpen && i === array.length - 1}
                  executionStatus={data.status}
                />
              );
            })
          : null}
        {!data.api_test_executions.length &&
        ![CREATED, RUNNING].includes(data?.status) ? (
          <div className={commonC('__empty-state-container')}>
            <Empty.State
              title={t('testDetails_empty_state_no_console_data_to_show')}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

const getExecParams = (exec: any) => {
  const length = exec.api_test_executions?.length || 0;
  const lastUseCase = length > 0 ? exec.api_test_executions[length - 1] : {};
  const creation = [];
  const errors = [];

  if (length) {
    for (let i = 0; i < exec.api_test_executions?.length; i++) {
      const useCase = exec.api_test_executions[i];
      if (useCase.status === 'Failed') errors.push(useCase.test_case_tag);
      if (
        [TEST_STATUSES.CANCELLED, TEST_STATUSES.CREATED].includes(
          useCase.status,
        )
      )
        creation.push(useCase.test_case_tag);
    }
  }

  return [
    errors[0],
    creation[0],
    [TEST_STATUSES.CANCELLED, TEST_STATUSES.CREATED].includes(
      lastUseCase.status,
    ),
  ];
};
